import React, { forwardRef } from 'react';
import * as icons from '../../icons';

export const MyIcon = forwardRef<
  SVGSVGElement,
  {
    name: string;
    style?: React.CSSProperties;
    className?: string;
  }
>(({ name, style, className }, ref) => {
  const IconComponent = icons[name as keyof typeof icons];
  if (!IconComponent) return null;
  return <IconComponent ref={ref} style={style} className={className} />;
});
